export const times = [
    { "id": "0", "value": "None" },
    { "id": "1", "value": "Thị trường có tin mạnh" },
    { "id": "2", "value": "Mở cửa thị trường" },
    { "id": "3", "value": "Giao phiên Âu - Mỹ" },
    { "id": "4", "value": "Ngày đặc biệt" }
]